<template>
  <div>
    <v-card class="text-xs-center mt-4" hover>
      <div style="position: absolute; right: 3px; top: 3px">
        <v-btn flat icon color="grey" @click="edit = true" v-if="userAuthClass">
          <v-icon>edit</v-icon>
        </v-btn>
      </div>

      <div class>
        <v-avatar :color="color" size="66" class="overlap-avatar">
          <span class="white--text headline">{{letter.toUpperCase()}}</span>
        </v-avatar>
      </div>
      <router-link router :to="{ name: 'project', query: {fid: client.id} }" tag="div">
        <v-card-text @click="detailDialog = true">
          <div class="pb-3">
            <h5 class="subheading font-weight-regular text-capitalize">{{client.name}}</h5>
          </div>
          <div class="pb-4">
            <h5
              class="subheading font-weight-regular grey--text text--darken-1"
            >{{client.contactEmail}}</h5>
          </div>
          <div class="pb-4">
            <h5
              class="subheading font-weight-regular grey--text text--darken-1"
            >{{client.contactPhone}}</h5>
          </div>
        </v-card-text>
      </router-link>

      <v-card-actions>
        <v-btn
          flat
          icon
          color="grey"
          :href="'tel:'+client.contactPhone"
          v-if="!!client.contactPhone"
        >
          <v-icon>phone</v-icon>
        </v-btn>
        <v-btn
          flat
          icon
          color="grey"
          :href="'mailto:'+client.contactEmail"
          v-if="!!client.contactEmail"
        >
          <v-icon>mail</v-icon>
        </v-btn>

        <v-spacer></v-spacer>
        <v-btn flat icon color="red lighten-3" @click="deleteDialog = true" v-if="userAuthClass">
          <v-icon>delete</v-icon>
        </v-btn>
      </v-card-actions>
      <slot name="parentActions"></slot>
      <div class="card-divider grey lighten-2" style="margin-top: 0px;"></div>

      <div class="card-footer text-xs-left">
        <time-ago class="grey--text" :subject="client" :time="client.updatedAt" needsParse updated>
          <v-icon small color="grey" slot="icon" class="mr-2">access_time</v-icon>
        </time-ago>

      </div>
      <div style="width: 100%; height: 2px;" :class="color"></div>
    </v-card>

    <!--EDIT DIALOG -->
    <v-dialog v-model="edit" max-width="700px" @keydown.esc="edit = false">
      <edit-client :client="client" @close="edit = false"></edit-client>
    </v-dialog>

    <!-- DETAIL DIALOG -->
    <!-- <v-dialog v-model="detailDialog" fullscreen hide-overlay transition="scale-transition">
            <client-detail @close="detailDialog = false" :client = "client" :color="color"></client-detail>
    </v-dialog>-->

    <!-- DELETE CONFIRMATION DIALOG -->
    <v-dialog v-model="deleteDialog" max-width="400px" @keydown.esc="deleteDialog = false">
      <v-card>
        <v-card-title class="headline">
          <span>
            Really delete?
            <span class="grey--text subheading">- {{client.name}}</span>
          </span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat @click="deleteDialog = false">Cancel</v-btn>
          <v-btn color="red darken-1" flat @click="deleteClient(); deleteDialog = false">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import ClientService from "@/services/requests/clientService";
import getColorFromChar from "@/services/helpers/getColorFromChar";
import EditClient from "@/components/clients/editClient";
import ClientDetail from "@/components/clients/clientDetail";
export default {
  components: {
    ClientDetail,
    EditClient
  },

  data() {
    return {
      edit: false,
      deleteDialog: false
    };
  },
  methods: {
    deleteClient() {
      var client = this.client;
      ClientService.deleteClient(client.id)
        .then(result => {
          //console.log(result.data);
          this.$store.commit("clients/deleteFromArrayStateByValue", {
            prop: "clients",
            value: client
          });
          this.snack({ text: "Client was deleted!", color: "yellow" });
        })
        .catch(err => {
          this.snackError();
        });
    }
  },
  props: {
    client: Object,
    index: Number
  },
  computed: {
    color() {
      return getColorFromChar(this.client.name.charCodeAt(0));
    },
    letter() {
      return this.client.name.charAt(0);
    }
  }
};
</script>

<style scoped>
.clickable {
  cursor: pointer;
}
.overlap-avatar {
  margin-top: -35px;
  border: 6px solid #eee;
  border-color: #eee !important;
}
</style>
